import { render, staticRenderFns } from "./PrescriptionDetailInputForm.vue?vue&type=template&id=19bb3747&scoped=true&"
import script from "./PrescriptionDetailInputForm.vue?vue&type=script&lang=js&"
export * from "./PrescriptionDetailInputForm.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionDetailInputForm.vue?vue&type=style&index=0&id=19bb3747&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb3747",
  null
  
)

export default component.exports